const Footer = () => {
    return (
        <>
            <div className="card">
                <h1>Footer</h1>
                <div className="footer">
                    <h4>GitHub-Finder | Designed and developed by <a href="https://www.linkedin.com/in/sonu-kumar-1110b81a0/" target="_blank" rel="noreferrer">Sonu</a> | &copy;2022</h4>
                    <h4>Made with 🧡</h4>
                </div>
            </div>
        </>
    )
}

export default Footer;